(function () {
  function initSocialFeed(section) {
    if (!section || typeof Swiper === "undefined") return;

    const slider = section.querySelector(".blj-social-feed__swiper");
    if (!slider || slider.dataset.initialized === "true") return;

    slider.dataset.initialized = "true";

    new Swiper(slider, {
      slidesPerView: 2.2,
      spaceBetween: 16,
      navigation: {
        nextEl: section.querySelector(".blj-social-feed__arrow--next"),
        prevEl: section.querySelector(".blj-social-feed__arrow--prev")
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-social-feed-section]").forEach(initSocialFeed);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initSocialFeed(event.target);
  });
})();
